<div *ngIf="message && message['type']" class="alert" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error', 'alert-warning': message.type === 'warning', 'alert-info': message.type === 'info' }" (dblclick)="onClose()">
  <button type="button" class="close" (click)="onClose()"><i class="material-icons">close</i></button>
  {{message.text}}
  <span *ngFor="let m of message.texts">{{ m }}<br></span>
</div>
